import { RoamingInfo } from "@/services/model";
import { ServiceIDs } from "@/utils/constants";
import { getRoamingDataGb } from "@/utils/productMatrix";

// The included roaming volume in MB, from the product matrix. Unknown service
// ids fall back to Flat Mobile Two, as before.
const getMaxVolume = (serviceId?: number) =>
  (getRoamingDataGb(serviceId) ??
    getRoamingDataGb(ServiceIDs.FlatMobileTwoMonth) ??
    0) * 1024;

export const useShouldDisplayRoamingHints = ({
  roamingInfo,
  serviceId,
}: {
  roamingInfo: RoamingInfo;
  serviceId?: number;
}) => {
  // If the initial volume is less than x MB, we started the mobile abo somewhere in the middle of the month. In this case, we show a hint to the user explaining the odd volume.
  const shouldDisplayPartialHint =
    typeof roamingInfo.initialVolume === "number" &&
    roamingInfo.initialVolume < getMaxVolume(serviceId);

  return {
    shouldDisplayPartialHint,
  };
};
